export { default } from "./SliderCustomLabelContainer";
